import PropTypes from 'prop-types'
import { SuggestionTypeTag } from './styled'
import { normalizeSuggestionType } from '../../utils/suggestion-type'

const getTagVariant = (description) => {
  switch (normalizeSuggestionType(description)) {
    case 'transfer order':
      return 'transfer'
    case 'stock return':
      return 'return'
    case 'purchase order':
      return 'purchase'
    default:
      return 'default'
  }
}

const SuggestionTypeTagComponent = ({ typeDescription }) => (
  <SuggestionTypeTag variant={getTagVariant(typeDescription)}>
    {typeDescription || '-'}
  </SuggestionTypeTag>
)

SuggestionTypeTagComponent.propTypes = {
  typeDescription: PropTypes.string
}

export default SuggestionTypeTagComponent
